import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { BasicTooltip } from '@nivo/tooltip';
import { theme } from './chartTheme';

const Bar = ({
  x,
  y,
  width,
  height,
  color,
  data,
  showTooltip,
  hideTooltip,
  onClick,
  getTooltipLabel,
  tooltipFormat,
  tooltip,
  theme,
}) => {
  const tip = (
    <BasicTooltip
      id={getTooltipLabel(data)}
      value={data.value}
      enableChip={true}
      color={color}
      theme={theme}
      format={tooltipFormat}
      renderContent={typeof tooltip === 'function' ? tooltip.bind(null, { color, theme, ...data }) : null}
    />
  );
  const handleTooltip = e => showTooltip(tip, e);
  const handleMouseEnter = e => {
    showTooltip(tip, e);
  };
  const handleMouseLeave = e => {
    hideTooltip(e);
  };
  const baseOpts = {
    height,
    rx: '3',
    ry: '3',
    fill: color,
    stroke: color,
    strokeWidth: '0',
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleTooltip,
    onMouseLeave: handleMouseLeave,
  };
  const barWidth = width * 1.5;
  return data.id === data.data.onceKey ? (
    <g transform={`translate(${x + width - barWidth / 2}, ${y})`}>
      <rect width={barWidth} {...baseOpts}></rect>
    </g>
  ) : (
    <g transform={`translate(${barWidth / 2 - barWidth / 4 + x}, ${y})`}>
      <rect width={barWidth / 4} {...baseOpts}></rect>
    </g>
  );
};

const OrdersChart = ({ keys, data }) => {
  return (
    <ResponsiveBar
      data={data}
      indexBy="period"
      keys={keys}
      margin={{ top: 5, right: 20, bottom: 35, left: 40 }}
      padding={0}
      groupMode="grouped"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 11,
        tickRotation: 0,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
      }}
      tooltip={({ id, value, color }) => (
        <div style={{ color }}>
          {id}: {value}
        </div>
      )}
      colors={({ id, data }) => data[`${id}Color`]}
      barComponent={Bar}
      enableLabel={false}
      animate={true}
      theme={theme}
    />
  );
};

export default OrdersChart;
